import { Pipe, PipeTransform } from '@angular/core';

import _ from 'lodash';

@Pipe({
    name: 'enumKeyValueList',
    standalone: false
})

export class EnumKeyValueListPipe implements PipeTransform {
    transform(value: any, args: any[]): any {
        value = value || {};
        const keys = Object.getOwnPropertyNames(value);

        const results = _(keys)
            .filter((key: string) => !isNaN(parseInt(key)))
            .uniq()
            .map((key: string | number) => { return { key: key, value: value[key] } })
            .value();
    }
}